module.exports = __webpack_public_path__ + "static/media/abp.63c16ea6.png";